/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "scroll-hint/css/scroll-hint.css"


export const shouldUpdateScroll = ({ pathname }: { pathname: string }) => {
  if (pathname.includes("-more-")) return false

  return true
}

export const onRouteUpdate = () => {
  // @ts-ignore
  if (window.LineIt) window.LineIt.loadButton()

  // @ts-ignore
  if (window.FB) {
    // @ts-ignore
    window.FB.init({
      xfbml: true,
      version: "v20.0",
    })
  }

  // Initialize LuckyWP Table of Contents
  initLwptoc()

  // Initialize scroll hint for tables (mobile only)
  initScrollHint()
}

function initScrollHint() {
  // Only on mobile devices (max-width: 767px)
  if (window.innerWidth > 767) return

  // Find scrollable tables
  const tables = document.querySelectorAll(".wp-block-table")

  tables.forEach(table => {
    // Skip if already initialized
    if (table.getAttribute("data-scroll-hint-initialized")) return
    table.setAttribute("data-scroll-hint-initialized", "1")

    const tableEl = table as HTMLElement

    // Only show hint if table actually needs horizontal scroll
    if (tableEl.scrollWidth <= tableEl.clientWidth) return

    // Create hint element using scroll-hint styles
    const hintWrap = document.createElement("div")
    hintWrap.className = "scroll-hint-icon-wrap"
    hintWrap.innerHTML = `
      <div class="scroll-hint-icon">
        <span class="scroll-hint-text">スクロールできます</span>
      </div>
    `
    tableEl.style.position = "relative"
    tableEl.insertBefore(hintWrap, tableEl.firstChild)

    // Show hint when table enters viewport
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            hintWrap.classList.add("is-active")
            // Hide after 3 seconds
            setTimeout(() => {
              hintWrap.classList.remove("is-active")
            }, 3000)
            // Only show once
            observer.disconnect()
          }
        })
      },
      { threshold: 0.3 }
    )

    observer.observe(tableEl)

    // Hide on scroll
    tableEl.addEventListener("scroll", () => {
      hintWrap.classList.remove("is-active")
    }, { once: true })
  })
}

function initLwptoc() {
  const tocContainers = document.querySelectorAll(".lwptoc")

  tocContainers.forEach(container => {
    // Skip if already initialized
    if (container.getAttribute("data-lwptoc-gatsby-initialized")) return
    container.setAttribute("data-lwptoc-gatsby-initialized", "1")

    // Toggle functionality
    const toggleLabel = container.querySelector(".lwptoc_toggle_label")
    const items = container.querySelector(".lwptoc_items")

    if (toggleLabel && items) {
      const showLabel = toggleLabel.getAttribute("data-label") || "表示"
      const hideLabel = toggleLabel.textContent || "非表示"
      const itemsEl = items as HTMLElement

      // Set initial max-height for animation
      if (items.classList.contains("lwptoc_items-visible")) {
        itemsEl.style.maxHeight = itemsEl.scrollHeight + "px"
      }

      toggleLabel.addEventListener("click", (e: Event) => {
        e.preventDefault()
        const isVisible = items.classList.contains("lwptoc_items-visible")

        if (isVisible) {
          // Collapse animation
          itemsEl.style.maxHeight = itemsEl.scrollHeight + "px"
          // Force reflow
          itemsEl.offsetHeight
          items.classList.add("lwptoc_items-hiding")
          items.classList.remove("lwptoc_items-visible")
          itemsEl.style.maxHeight = "0"
          toggleLabel.textContent = showLabel

          // After animation, set display none
          setTimeout(() => {
            if (!items.classList.contains("lwptoc_items-visible")) {
              itemsEl.style.display = "none"
            }
          }, 300)
        } else {
          // Expand animation
          itemsEl.style.display = "block"
          items.classList.remove("lwptoc_items-hiding")
          items.classList.add("lwptoc_items-visible")
          itemsEl.style.maxHeight = itemsEl.scrollHeight + "px"
          toggleLabel.textContent = hideLabel

          // After animation, remove max-height constraint
          setTimeout(() => {
            if (items.classList.contains("lwptoc_items-visible")) {
              itemsEl.style.maxHeight = "none"
            }
          }, 300)
        }
      })
    }

    // Smooth scroll functionality
    const links = container.querySelectorAll(".lwptoc_item a")
    const smoothScroll = container.getAttribute("data-smooth-scroll") === "1"
    const defaultOffset = parseInt(
      container.getAttribute("data-smooth-scroll-offset") || "24",
      10
    )

    links.forEach(link => {
      link.addEventListener("click", (e: Event) => {
        const href = link.getAttribute("href")
        if (!href || !href.startsWith("#")) return

        const targetId = href.slice(1)
        const targetElement = document.getElementById(targetId)

        if (targetElement) {
          e.preventDefault()

          // Calculate offset including floating header
          const floatingHeader = document.querySelector(
            '[class*="FloatingTopMenuBar"]'
          )
          const headerOffset = floatingHeader
            ? (floatingHeader as HTMLElement).offsetHeight
            : 0
          const totalOffset = headerOffset + defaultOffset

          const targetPosition =
            targetElement.getBoundingClientRect().top +
            window.pageYOffset -
            totalOffset

          if (smoothScroll) {
            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            })
          } else {
            window.scrollTo(0, targetPosition)
          }

          // Update URL hash without scrolling
          history.pushState(null, "", href)
        }
      })
    })
  })
}
